export enum Actions {
  CONNECTED = '@@streamApi/CONNECTED',
  ERROR = '@@streamApi/ERROR',
  CLOSED = '@@streamApi/CLOSED',
  SEND_MESSAGE = '@@streamApi/SEND_MESSAGE',
  RECEIVED_DEVICE_READING = '@@streamApi/RECEIVED_DEVICE_READING',
  RECEIVED_SUBSCRIBED_INCIDENT = '@@streamApi/RECEIVED_SUBSCRIBED_INCIDENT',
}

export enum CommandType {
  SUBSCRIBE = 'SUBSCRIBE',
  UNSUBSCRIBE = 'UNSUBSCRIBE',
}

export enum Channel {
  SENSOR_READINGS = 'SENSOR_READINGS',
  INCIDENT_INFO = 'INCIDENT_INFO',
}

export const subscribeToIncident = ({
  equipmentId,
  spaceId,
}: {
  equipmentId?: number | string;
  spaceId?: number | string;
}) => ({
  type: Actions.SEND_MESSAGE,
  data: {
    type: CommandType.SUBSCRIBE,
    channel: Channel.INCIDENT_INFO,
    equipmentId,
    spaceId,
  },
});

export const unsubscribeFromIncident = ({
  equipmentId,
  spaceId,
}: {
  equipmentId?: number | string;
  spaceId?: number | string;
}) => ({
  type: Actions.SEND_MESSAGE,
  data: {
    type: CommandType.UNSUBSCRIBE,
    channel: Channel.INCIDENT_INFO,
    equipmentId,
    spaceId,
  },
});

export const subscribeToDeviceReadings = (
  vendor: string,
  uuid: string,
  id?: number | string
) => {
  return {
    type: Actions.SEND_MESSAGE,
    data: {
      type: CommandType.SUBSCRIBE,
      channel: Channel.SENSOR_READINGS,
      vendor,
      uuid,
      id,
    },
  };
};

export const unsubscribeFromDeviceReadings = (
  vendor: string,
  uuid: string,
  id?: number | string
) => ({
  type: Actions.SEND_MESSAGE,
  data: {
    type: CommandType.UNSUBSCRIBE,
    channel: Channel.SENSOR_READINGS,
    vendor,
    uuid,
    id,
  },
});
